import { Box } from '@mui/material';
import { JSX, ReactNode } from 'react';
import clsx from 'clsx';

interface PolicyCardsContainerProps {
  className?: string;
  children: ReactNode;
}

/**
 * A container for policy cards. Displays the cards in a grid.
 */
const PolicyCardsContainer = ({ className, children }: PolicyCardsContainerProps): JSX.Element => (
  <Box className={clsx('grid md:grid-cols-2 gap-12', className)}>{children}</Box>
);

export default PolicyCardsContainer;
